<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.blisscipline.workouts.index'),
          title: 'Blisscipline workouts',
        },
      ]"
      :title="title"
    />
    <div class="card card-body">
      <form action="" method="post" @submit.prevent="submit" v-if="formSet">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label for="blisscipline_id">Blissdom</label>
              <AdvanceSelect
                class="advance-dpdown"
                :options="blissciplines"
                :reduce="(item) => item.id"
                id="blisscipline_id"
                label="title"
                placeholder="Select blissdom"
                :disabled="form.processing"
                :class="{ 'is-invalid': form.errors.blisscipline_id }"
                v-model="form.blisscipline_id"
              >
              </AdvanceSelect>
              <transition name="form-error">
                <div
                  class="error"
                  v-if="form.errors.blisscipline_id"
                  v-text="form.errors.blisscipline_id"
                ></div>
              </transition>
            </div>
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              name="sort_order"
              v-model="form.sort_order"
              :disabled="form.processing"
              :error="form.errors.sort_order"
              helperText="Higher the number, higher the priority"
            />
            <TextBox
              type="textarea"
              name="description"
              v-model="form.description"
              :disabled="form.processing"
              :error="form.errors.description"
            />
            <TextBox
              type="editor"
              name="instructions"
              v-model="form.instructions"
              :disabled="form.processing"
              :error="form.errors.instructions"
            />
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-6">
                <TextBox
                  name="minutes"
                  v-model="form.minutes"
                  :disabled="form.processing"
                  :error="form.errors.minutes"
                />
              </div>
              <div class="col-lg-6">
                <TextBox
                  name="seconds"
                  v-model="form.seconds"
                  :disabled="form.processing"
                  :error="form.errors.seconds"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="animation">Animation/Video</label>
              <div class="custom-file">
                <input
                  name="animation"
                  type="file"
                  class="custom-file-input"
                  id="animation"
                  accept="video/*"
                  :disabled="form.processing"
                  :class="{ 'is-invalid': form.errors.animation }"
                  @change="fileOnChange"
                />
                <label
                  class="custom-file-label"
                  for="animation"
                  v-text="fileName"
                ></label>
              </div>
              <small class="text-dim font-weight-bold" v-if="editMode"
                >Leave blank to keep existing file</small
              >
              <transition name="form-error">
                <div
                  class="error"
                  v-if="form.errors.animation"
                  v-text="form.errors.animation"
                ></div>
              </transition>
            </div>
            <FileInput
              name="thumbnail"
              v-model="form.thumbnail"
              :fileUrl="form.thumbnail_url"
              :disabled="form.processing"
              :error="form.errors.thumbnail"
              helperText="Upload svg file for better quality"
            />
            <div class="row">
              <div class="col-auto">
                <StatusRadio
                  v-model="form.isactive"
                  :disabled="form.processing"
                  :error="form.errors.isactive"
                />
              </div>
              <div class="col-auto">
                <StatusRadio
                  label="Premium content"
                  :radioLabel="['Premium', 'Free']"
                  name="is_premium"
                  v-model="form.is_premium"
                  :disabled="form.processing"
                  :error="form.errors.is_premium"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <hr />
            <div class="text-center text-lg-right">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import "@/helpers/summernote/summernote-bs4.min.js";
import "@/helpers/summernote/summernote-bs4.min.css";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    blissciplines: {
      type: [Object, Array],
      default: () => [],
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AdvanceSelect: vSelect,
    FileInput,
  },
  data() {
    return {
      form: {},
      formSet: false,
      fileName: "Choose file",
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.fileName = this.form.animation || "Choose file";
      this.form.animation = null;
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
    fileOnChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = () => {
        this.fileName = event.target.files[0].name;
        this.form.animation = event.target.files[0];
      };
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.content-type-help {
  padding: 1rem;
  border: 2px solid var(--warning);
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
</style>